import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	components: {
		MuiInputBase: {
			styleOverrides: {
				input: {
					"&.MuiAutocomplete-input": {
						margin: "0 auto !important",
					},
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				select: {
					fontSize: "13px", // выбранный текст
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					fontSize: "13px", // label над селектом
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					fontSize: "13px", // выпадающие элементы
				},
			},
		},
	},
	palette: {
		text: {
			primary: "#918c8c",
		},
		secondary: { main: "#918c8c" },
		error: { main: "#db6969" },
	},
	shape: {
		borderRadius: 4,
	},
});

export default theme;
